import { useAccount, useBalance } from 'wagmi';
import { formatUnits } from 'viem';
import { useEffect, useRef, useState } from 'react';

export const useSeiBalance = () => {
  const { address, isConnected } = useAccount();
  const errorCountRef = useRef(0);
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const {
    data: balanceData,
    isLoading,
    isError,
    error,
    refetch,
  } = useBalance({
    address: address,
    // Auto refetch every 10 seconds
    query: {
      enabled: isConnected && !!address,
      refetchInterval: 10000,
    },
  });

  // Monitor connection issues and handle session expiration
  useEffect(() => {
    if (isConnected && address && isError && error) {
      errorCountRef.current += 1;

      // If we get 3 consecutive errors, likely a session issue
      if (errorCountRef.current >= 3) {
        setIsSessionExpired(true);
      }
    } else if (!isError && balanceData) {
      // Reset error count on successful fetch
      errorCountRef.current = 0;
      setIsSessionExpired(false);
    }
  }, [isConnected, address, isError, error, balanceData]);

  // Return formatted balance as number
  const balance = balanceData
    ? parseFloat(formatUnits(balanceData.value, balanceData.decimals))
    : 0;

  return {
    balance,
    formattedBalance: balanceData
      ? `${formatUnits(balanceData.value, balanceData.decimals)} ${balanceData.symbol}`
      : '0 SEI',
    symbol: balanceData?.symbol || 'SEI',
    decimals: balanceData?.decimals || 18,
    isLoading,
    isError,
    error,
    refetch, // Export refetch function for manual refresh
    isSessionExpired, // Export session expired state
  };
};
